import {Component, Injector} from '@angular/core';
import {DialogBaseComponent} from "../../base-admin-panel/dialog-base/dialog-base.component";
import {ShiftViewModel} from "../Models/ShiftViewModel";

@Component({
    selector: 'app-shifts-dialog-base',
    templateUrl: './shifts-dialog-base.component.html',
    styleUrls: ['./shifts-dialog-base.component.css'],
    standalone: false
})
export class ShiftsDialogBaseComponent extends DialogBaseComponent<ShiftViewModel> {
  constructor(protected injector: Injector) {
    super(injector);
  }


}
